module.exports = __webpack_public_path__ + "static/media/rumbleon-black-logo.819f8967.svg";